import type { FC } from 'react';

import type { Nullable } from '@zen/utils/typescript';

import TerminalsAndGroupsSelect, { type TerminalOrGroup } from '../../TerminalsAndGroupsSelect';
import type { FormFieldProps } from '../FormField';
import FormField from '../FormField';
import type { FormInstance } from '../types';

interface Props extends FormFieldProps {
  includeGroups?: boolean;
  isClearable?: boolean;
  isDisabled?: boolean;
  renderMenuInPortal?: boolean;
}

const FormTerminalsAndGroupsSelect: FC<Props> = (props) => {
  const { label, ...rest } = props;

  return (
    <FormField {...props}>
      {(
        field: { error: boolean; label: string; name: string; value: Nullable<TerminalOrGroup> },
        form: FormInstance<unknown>
      ) => {
        const { label: fieldLabel, ...fieldRest } = field;

        return (
          <TerminalsAndGroupsSelect
            {...rest}
            {...fieldRest}
            hasError={field.error}
            onChange={(value: Nullable<TerminalOrGroup>) => {
              form.setFieldValue(field.name, value);
            }}
          />
        );
      }}
    </FormField>
  );
};

export type { Props as FormTerminalsAndGroupsSelectProps };

export default FormTerminalsAndGroupsSelect;
